module.exports = __webpack_public_path__ + "static/media/wyse.2bd6e696.png";